import landingsData from '../TemplateLandingPages';
import {Utils} from '../underscore-extensions';

class LandingTemplate implements ng.IComponentController {
    private landingData: anm.LandingData;
    private scopeList = [] as ng.IScope[];

    constructor(private $state: ng.ui.IStateService,
                private $element: ng.IAugmentedJQuery,
                private $rootScope: ng.IRootScopeService,
                private $compile: ng.ICompileService) {
        this.landingData = landingsData.find(landing => this.$state.is(landing.url));
    }

    $onInit() {
        this.compileSections();
    }

    $onDestroy() {
        this.scopeList.forEach((scope: ng.IScope) => scope.$destroy());
    }

    private compileSections() {
        const sectionsContainerEl = angular.element(this.$element[0].querySelector('#sections'));
        const getKey = (key: string) => {
            const curKey = key === 'title' ? 'ltTitle' : key;
            return Utils.toHyphenCase(curKey)
        };
        const sectionDataToString = _.compose(
            ((attrsArr: string[]) => attrsArr.join(' ')),
            ((keys: string[]) => keys.map(key => `${getKey(key)}="${key}"`)),
            _.keys,
        );

        this.landingData.sections.forEach(section => {
            const attrs = sectionDataToString(section);
            const sectionEl = angular.element(`<section-${section.name} ${attrs}></section-${section.name}>`);
            const scope = Object.assign(this.$rootScope.$new(), section);
            this.scopeList.push(scope);
            sectionsContainerEl.append(this.$compile(sectionEl)(scope));
        });
    }
}

angular.module('animatronApp.landingTemplate', []).component('landingTemplate', {
    controller: LandingTemplate,
    templateUrl: require('landing-template/landing-template.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/LandingTemplate.ts